import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
  userDetails,
} from "../../../../../../utils/commonQueryTypes";
import {AtsStckItem} from "../../items/queries/types";

export enum AtsItemGroupOrderField {
  CREATED_AT = "CREATED_AT",
  GROUP_NAME = "GROUP_NAME",
  SL_NO = "SL_NO",
}

export interface GetItemGroupsVars extends commonPaginationTypes {
  customerID: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsItemGroupOrderField;
  };
  name: string;
}

export interface AtsItemGroup {
  id: number;
  groupName: string;
  slNo: number;
  customerID: number;
  totalQty: number;
  groupAssoicDetails: AtsItemGroupAssoic[];
}

export interface AtsItemGroupEdge {
  node: AtsItemGroup;
  cursor: string;
}

interface GetItemGroupsData {
  edges: AtsItemGroupEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetItemGroupsResult {
  GetItemGroups: GetItemGroupsData;
}

//Mutations

export interface AddItemGroupVar extends commonMutationTypes {
  groupName: string;
  customerID: number;
}

export interface AddItemGroupResult {
  AddItemGroup: boolean;
}

export interface UpdateItemGroupVar extends commonMutationTypes {
  itemGrpID: number;
  groupName: string;
}

export interface UpdateItemGroupResult {
  UpdateItemGroup: boolean;
}

export interface DeleteItemGroupByIdResult {
  DeleteItemGroup: boolean;
}

export interface DeleteItemGroupByIdVars extends commonMutationTypes {
  itemGrpID: number;
}

interface AddItemsInput {
  qtyNeeded: number;
  itemID: number;
}

export interface DeleteItemsInput {
  itemGrpAssoicID: number;
}

export interface AddOrUpdateOrDeleteItemGroupAssoicVars
  extends commonMutationTypes {
  customerID: number;
  itemGrpID: number;
  items: {
    AddItems: AddItemsInput[];
    UpdateItems: AddItemsInput[];
    DeleteItems: DeleteItemsInput[];
  };
}

export interface AddOrUpdateOrDeleteItemGroupAssoicResult {
  AddOrUpdateOrDeleteItemGroupAssoic: boolean;
}

export interface AtsItemGroupAssoic {
  id: number;
  slNo: number;
  qtyNeeded: number;
  customerID: number;
  itemGrpID: number;
  itemID: number;
  itemDetails: AtsStckItem;
  itemGrpDetails: {
    groupName: string;
  };
}

export interface GetItemGroupAssoicResult {
  GetItemGroupAssoic: AtsItemGroupAssoic[];
}

export interface GetItemGroupAssoicVar {
  customerID: number;
  itemGrpID: number;
}

export interface AddItemGroupAssemblyResult {
  AddItemGroupAssembly: boolean;
}

export interface GroupAssembly {
  mapNo: string;
  date: string;
  serialNo: string;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  ldgrID: number;
  itemGrpID: number;
  itemDetailsIds: number[];
}

export interface AddItemGroupAssemblyVars {
  customerID: number;
  user_details: userDetails;
  input: GroupAssembly;
}

export enum AtsItemGroupAssmbldOrderField {
  CREATED_AT = "CREATED_AT",
  DESC = "DESC",
}

export interface AtsItemGroupAssmbldOrder {
  direction: OrderDirection;
  field: AtsItemGroupAssmbldOrderField;
}
export interface GetItemGroupAssembliesVars {
  customerID: number;
  after: string | null;
  first: number | null;
  name: string | null;
  orderBy: AtsItemGroupAssmbldOrder | null;
}

export interface GetItemGroupAssembliesEdge {
  node: ItemGroupAssemblyNode;
}
export interface GetItemGroupAssembliesResponse {
  GetItemGroupAssemblies: {
    edges: GetItemGroupAssembliesEdge[];
    pageInfo: PageInfo;
    totalCount: number;
  };
}

export interface ItemGroupAssemblyNode {
  id: number;
  groupName: string;
  slNo: number;
  customerID: string;
  totalQty: number;
  groupAssoicDetails: GroupAssocDetail[];
}

export interface GroupAssocDetail {
  id: string;
  itemDetails: {
    id: string;
    desc: string;
  };
}

export interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

export interface GetItemGroupAssemblyDetailsVars {
  customerID: number;
  itemGrpID: number;
  itemGrpAssmbldID: number;
}

export interface AssemblyItemDetailsData {
  prodSerialNo: string;
  qrCode: string;
  alias: string;
  itemDetailsID: number;
}
export interface AssemblyItemData {
  desc: string;
  itemID: number;
  AssemblyItemDetails: AssemblyItemDetailsData[];
}

export interface AssemblyItemDataType {
  desc: string;
  itemID: number;
  itemDetails: AssemblyItemDetailsData[];
}

export interface GetItemGroupAssemblyDetailsDataType {
  id: number;
  mapNo: string;
  itemGrpID: string;
  grouping_name: string;
  totalQty: number;
  asset_list: AssemblyItemDataType[];
}

export interface GetItemGroupAssemblyDetailsData {
  id: number;
  mapNo: string;
  itemGrpID: string;
  groupName: string;
  totalQty: number;
  AssemblyItem: AssemblyItemData[];
}
export interface GetItemGroupAssemblyDetailsResponse {
  GetItemGroupAssemblyDetails: GetItemGroupAssemblyDetailsData[];
}

export interface nodeVar {
  id: number;
  token?: string;
}

export interface UpdateItemGroupAssemblyResult {
  UpdateItemGroupAssembly: boolean;
}

export interface UpdateItemGroupAssemblyVars {
  itemGrpAssmbldID: number;
  user_details: userDetails;
  input: GroupAssembly;
}

export interface DeleteItemGroupAssemblyResult {
  DeleteItemGroupAssembly: boolean;
}

export interface DeleteItemGroupAssemblyVars {
  itemGrpAssmbldID: number;
  user_details: userDetails;
}
